module.exports = __webpack_public_path__ + "img/DNADamage-PRCA_10X_ANS.7ab430e0.png";